





























































import { Component, Prop, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import UpdateAgencyUserGeneralDetailsRequest from '@/models/AgencyUsers/UpdateAgencyUserGeneralDetailsRequest';

@Component({
    name: 'AgencyUserRolesEdit'
})
export default class extends GiganautVueDialog {

  @Prop({ required: true }) agencyUserId!: string;

  public isAdministrator = false;
  public selectedRoleIds: string[] = [];

  @Watch('dialog')
  async onDialogChanged(val: boolean) {
    if (val) {
      const user = AgencySettingsModule.currentAgencyUser;
      this.isAdministrator = user.isAdministrator;
      if (AgencySettingsModule.agencyRoles.length === 0) {
        await AgencySettingsModule.getAgencyRoles();
      }
      this.selectedRoleIds = AgencySettingsModule.currentUserAgencyRoles.map(r => r.id);
    }
  }

  get availableRoles() {
    return AgencySettingsModule.agencyRoles.filter(r => r.status === 90);
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
    const user = AgencySettingsModule.currentAgencyUser;

    // Save isAdministrator via the general-details endpoint
    if (this.isAdministrator !== user.isAdministrator) {
      const request = new UpdateAgencyUserGeneralDetailsRequest();
      request.updatedAt = user.updatedAt;
      request.firstName = user.person.firstName;
      request.lastName = user.person.lastName;
      request.emailAddress = user.user.username;
      request.mobilePhoneNumber = user.mobilePhoneNumber;
      request.otherPhoneNumber = user.otherPhoneNumber;
      if (user.defaultBranch) {
        request.defaultBranchId = user.defaultBranch.id;
      }
      if (user.defaultDesk) {
        request.defaultDeskId = user.defaultDesk.id;
      }
      request.isAdministrator = this.isAdministrator;
      await AgencySettingsModule.editAgencyUserGeneralDetails(request);
    }

    // Save role assignments
    if (!this.isAdministrator) {
      await AgencySettingsModule.setAgencyRolesForUser({
        agencyUserId: this.agencyUserId,
        roleIds: this.selectedRoleIds,
      });
    }

    this.dialog = false;
  }
}
